<ng-container *ngIf="tab5$ | async">
  <div class="help-center__content">
    <a *ngFor="let tab of tab5$ | async" href="{{ tab.contentUrl }}">{{ tab.title }}</a>
  </div>
</ng-container>
